import { useState } from "react";
import { RescisaoInputCard } from "./components/RescisaoInputCard";
import { RescisaoTrabalhistaResponse } from "./utils/rescisao.d";
import { RescisaoResponse } from "./components/RescisaoResponse";

export default function RescisaoTrabalhista() {
  const [results, setResults] = useState<RescisaoTrabalhistaResponse | null>(
    null
  );

  return (
    <>
      <RescisaoInputCard setResults={setResults} />
      {results && <RescisaoResponse results={results} />}
    </>
  );
}